import { resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = { class: "icad-filters" }
const _hoisted_2 = /*#__PURE__*/_createTextVNode(" Incident Search ")
const _hoisted_3 = { class: "icad-filters__form d-flex flex-column" }
const _hoisted_4 = { class: "icad-filters__section" }
const _hoisted_5 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "cad"
}, " CAD Number ", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "location"
}, " Location ", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("option", {
  class: "icad-filters__option",
  selected: "",
  value: ""
}, " Select ", -1)
const _hoisted_8 = ["value"]
const _hoisted_9 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "district"
}, " District ", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("option", {
  class: "icad-filters__option",
  selected: "",
  value: ""
}, " Select ", -1)
const _hoisted_11 = ["value"]
const _hoisted_12 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "brigade"
}, " Brigade ", -1)
const _hoisted_13 = /*#__PURE__*/_createElementVNode("option", {
  class: "icad-filters__option",
  selected: "",
  value: ""
}, " Select ", -1)
const _hoisted_14 = ["value"]
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "dateRangeOptions"
}, " Date Range ", -1)
const _hoisted_16 = ["value"]
const _hoisted_17 = ["value"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "fromdate"
}, " From ", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "todate"
}, " To ", -1)
const _hoisted_20 = { class: "icad-filters__section" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "type"
}, " Incident Type ", -1)
const _hoisted_22 = /*#__PURE__*/_createElementVNode("option", {
  class: "icad-filters__option",
  selected: "",
  value: ""
}, " Select ", -1)
const _hoisted_23 = { class: "icad-filters__section" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "status"
}, " Incident Status ", -1)
const _hoisted_25 = /*#__PURE__*/_createElementVNode("option", {
  class: "icad-filters__option",
  selected: "",
  value: ""
}, " Select ", -1)
const _hoisted_26 = ["value"]
const _hoisted_27 = { class: "icad-filters__section" }
const _hoisted_28 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "callsign"
}, " Call Sign ", -1)
const _hoisted_29 = /*#__PURE__*/_createElementVNode("label", {
  class: "icad-filters__label",
  for: "zone"
}, " Zone ", -1)
const _hoisted_30 = { class: "icad-filters__section form-controls row" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("button", {
      class: _normalizeClass(["icad-filters__button d-flex justify-content-between align-items-center", { open: _ctx.isOpen }]),
      onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.toggleMenu()))
    }, [
      _hoisted_2,
      _createVNode(_component_font_awesome_icon, {
        icon: "chevron-down",
        class: "icad-filters__button__icon"
      })
    ], 2),
    _createElementVNode("div", {
      class: _normalizeClass(["icad-filters__filters", { open: _ctx.isOpen }])
    }, [
      _createElementVNode("form", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _hoisted_5,
          _withDirectives(_createElementVNode("input", {
            class: "icad-filters__input",
            id: "cad",
            type: "text",
            placeholder: "e.g. F3008502",
            "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.eventStore.filters.cadNumber) = $event))
          }, null, 512), [
            [_vModelText, _ctx.eventStore.filters.cadNumber]
          ])
        ]),
        _createElementVNode("div", {
          class: _normalizeClass(["icad-filters__expandable-section", { open: _ctx.isLocationOpen }])
        }, [
          _hoisted_6,
          _withDirectives(_createElementVNode("select", {
            class: "icad-filters__select",
            id: "location",
            name: "location",
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.eventStore.filters.locationLevel1) = $event)),
            onChange: _cache[3] || (_cache[3] = ($event: any) => (_ctx.handleRegionSelected()))
          }, [
            _hoisted_7,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.regionStore.getRegions, (region) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "icad-filters__option",
                key: region.unitCode,
                value: region.unitCode
              }, _toDisplayString(region.unitName), 9, _hoisted_8))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.eventStore.filters.locationLevel1]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["icad-filters__expanded-section", { open: _ctx.isLocationOpen }])
          }, [
            _hoisted_9,
            _withDirectives(_createElementVNode("select", {
              class: "icad-filters__select",
              id: "district",
              name: "district",
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.eventStore.filters.locationLevel2) = $event)),
              onChange: _cache[5] || (_cache[5] = ($event: any) => (_ctx.handleDistrictSelected()))
            }, [
              _hoisted_10,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventStore.getDistrictOptions, (district) => {
                return (_openBlock(), _createElementBlock("option", {
                  class: "icad-filters__option",
                  key: district.unitCode,
                  value: district.unitCode
                }, _toDisplayString(district.unitName), 9, _hoisted_11))
              }), 128))
            ], 544), [
              [_vModelSelect, _ctx.eventStore.filters.locationLevel2]
            ])
          ], 2),
          _createElementVNode("div", {
            class: _normalizeClass(["icad-filters__expanded-section", { open: _ctx.isDistrictOpen }])
          }, [
            _hoisted_12,
            _withDirectives(_createElementVNode("select", {
              class: "icad-filters__select",
              id: "brigade",
              name: "brigade",
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.eventStore.filters.station) = $event))
            }, [
              _hoisted_13,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventStore.getBrigadeOptions, (brigade) => {
                return (_openBlock(), _createElementBlock("option", {
                  class: "icad-filters__option",
                  key: brigade.unitCode,
                  value: brigade.unitCode
                }, _toDisplayString(brigade.unitName), 9, _hoisted_14))
              }), 128))
            ], 512), [
              [_vModelSelect, _ctx.eventStore.filters.station]
            ])
          ], 2)
        ], 2),
        _createElementVNode("div", {
          class: _normalizeClass(["icad-filters__expandable-section", { open: _ctx.isDateOpen }])
        }, [
          _hoisted_15,
          _withDirectives(_createElementVNode("select", {
            class: "icad-filters__select",
            id: "dateselect",
            name: "dateselect",
            "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.dateSelect) = $event)),
            onChange: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.handleDateSelected && _ctx.handleDateSelected(...args)))
          }, [
            _createElementVNode("option", {
              class: "icad-filters__option",
              selected: "",
              value: _ctx.DATERANGES.DEFAULT
            }, _toDisplayString(_ctx.DATERANGES.DEFAULT), 9, _hoisted_16),
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.dateRangeOptions, (dateRange, i) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "icad-filters__option",
                key: i,
                value: dateRange.value
              }, _toDisplayString(dateRange.text), 9, _hoisted_17))
            }), 128))
          ], 544), [
            [_vModelSelect, _ctx.dateSelect]
          ]),
          _createElementVNode("div", {
            class: _normalizeClass(["icad-filters__expanded-section", { open: _ctx.isDateOpen }])
          }, [
            _hoisted_18,
            _withDirectives(_createElementVNode("input", {
              class: "icad-filters__date",
              id: "fromdate",
              name: "fromdate",
              type: "date",
              "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.customBegin) = $event))
            }, null, 512), [
              [_vModelText, _ctx.customBegin]
            ]),
            _hoisted_19,
            _withDirectives(_createElementVNode("input", {
              class: "icad-filters__date",
              id: "todate",
              name: "todate",
              type: "date",
              "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.customEnd) = $event))
            }, null, 512), [
              [_vModelText, _ctx.customEnd]
            ])
          ], 2)
        ], 2),
        _createElementVNode("div", _hoisted_20, [
          _hoisted_21,
          _withDirectives(_createElementVNode("select", {
            class: "icad-filters__select",
            id: "type",
            name: "type",
            "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.eventStore.filters.type) = $event))
          }, [
            _hoisted_22,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventStore.eventTypes, (eventType) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "icad-filters__option",
                key: eventType.eventTypeCode
              }, _toDisplayString(eventType.eventTypeCode), 1))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.eventStore.filters.type]
          ])
        ]),
        _createElementVNode("div", _hoisted_23, [
          _hoisted_24,
          _withDirectives(_createElementVNode("select", {
            class: "icad-filters__select",
            id: "status",
            name: "status",
            "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.eventStore.filters.state) = $event))
          }, [
            _hoisted_25,
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.eventStatusList, (eventStatus) => {
              return (_openBlock(), _createElementBlock("option", {
                class: "icad-filters__option",
                key: eventStatus.text,
                value: eventStatus.value
              }, _toDisplayString(eventStatus.text), 9, _hoisted_26))
            }), 128))
          ], 512), [
            [_vModelSelect, _ctx.eventStore.filters.state]
          ])
        ]),
        _createElementVNode("div", _hoisted_27, [
          _hoisted_28,
          _withDirectives(_createElementVNode("input", {
            class: "icad-filters__input",
            id: "callsign",
            type: "text",
            placeholder: "e.g. AUCK2010",
            "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.eventStore.filters.callSign) = $event))
          }, null, 512), [
            [_vModelText, _ctx.eventStore.filters.callSign]
          ]),
          _hoisted_29,
          _withDirectives(_createElementVNode("input", {
            class: "icad-filters__input",
            id: "zone",
            type: "text",
            placeholder: "e.g. 2973",
            "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.eventStore.filters.zone) = $event))
          }, null, 512), [
            [_vModelText, _ctx.eventStore.filters.zone]
          ])
        ]),
        _createElementVNode("div", _hoisted_30, [
          _createElementVNode("input", {
            class: "icad-filters__submit col-6",
            type: "submit",
            value: "Search",
            onClick: _cache[15] || (_cache[15] = 
//@ts-ignore
(...args) => (_ctx.handleSubmit && _ctx.handleSubmit(...args)))
          }),
          _createElementVNode("input", {
            class: "icad-filters__reset col-6",
            type: "reset",
            value: "Reset",
            onClick: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.handleReset && _ctx.handleReset(...args)))
          })
        ])
      ])
    ], 2)
  ]))
}